import React from "react";

/**
 * Reusable PopularItems component
 * Displays a grid of popular items with rankings and progress bars
 * @param {Object} props - Component props
 * @param {string} props.title - Title for the section
 * @param {Array} props.items - Array of items with name and sales properties
 * @param {string} props.itemLabel - Label for the item type (e.g., "orders", "sales")
 * @param {string} props.className - Additional CSS classes
 */
const PopularItems = ({
  title = "Popular Items",
  items = [],
  itemLabel = "orders",
  emptyMessage = "No data available",
  className = "",
}) => {
  const maxSales =
    items.length > 0 ? Math.max(...items.map((item) => item.sales)) : 0;

  return (
    <div className={`card p-6 ${className}`}>
      <h2 className="mb-6 text-lg font-semibold text-white">{title}</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {items.map((item, index) => (
          <div
            key={item.id || item.category_id || item.name}
            className="rounded-lg bg-gray-800 p-4"
          >
            <div className="mb-2 flex items-center justify-between">
              <span
                className="truncate font-medium text-white"
                title={item.name}
              >
                {item.name}
              </span>
              <span className="ml-2 flex-shrink-0 text-xs text-gray-400">
                #{index + 1}
              </span>
            </div>
            <div className="text-sm text-gray-400">
              {item.sales} {itemLabel}
            </div>
            <div className="mt-2 h-2 rounded-full bg-gray-700">
              <div
                className="bg-brand-gradient h-2 rounded-full transition-all duration-300"
                style={{
                  width: `${maxSales > 0 ? (item.sales / maxSales) * 100 : 0}%`,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      {items.length === 0 && (
        <div className="py-8 text-center">
          <div className="text-sm text-gray-400">{emptyMessage}</div>
        </div>
      )}
    </div>
  );
};

export default PopularItems;
